var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({
	
	openUrl : function(e){
		e.preventDefault();
		
		var url = $(e.currentTarget).attr('href');
				
		window.open(url,'_blank','width=500,height=500');	
	},
	
	// Render
  	render: function(){
  		
  		var self = this;
  		
  		//var job_url = 'http://apply.searchsoftware.nl/'+this.props.env+'/'+this.props.job.job_id+'/'+slugify(this.props.job.title);
  		
  		var job_url = 'http://jobs.searchsoftware.nl/'+this.props.env+'/'+this.props.job.job_id+'/'+slugify(this.props.job.title)
  		
  		if(typeof self.props.env_info.custom_job_board_domain != 'undefined' && self.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = self.props.env_info.custom_job_board_domain;
  			job_url = 'http://'+custom_domain+'/job/'+this.props.job.job_id+'/'+slugify(this.props.job.title)
  		}
  		
  		//console.log('share', this.props);
  		
  		// Use bitly
  		//var job_url = this.props.job.bitly;
  		
  		//var job_image = $("meta[property='og:image']").attr("content");
  		var job_image = (typeof window != 'undefined') ? $("meta[property='og:image']").attr("content") : '';
  		
  		var mailto = 'mailto:?subject='+this.props.job.title+'&body='+job_url;
  		
  		var linkedin_url = 'https://www.linkedin.com/shareArticle?title='+this.props.job.title+'&summary='+this.props.job.title+'&url='+job_url;
  		
  		var facebook_url = 'http://www.facebook.com/sharer.php?s=100&p[url]='+job_url+'&[images][0]='+job_image;
  		  		
  		var twitter_url = 'https://twitter.com/share?text='+this.props.job.title+'&url='+job_url+'&image='+job_image;
  		
  		var whatsapp_url = 'whatsapp://send?text='+encodeURIComponent(this.props.job.title+' '+job_url);
  		
  		var whatsapp_el = (<li className="whatsapp">
  			<a className="fa fa-whatsapp whatsapp" href={whatsapp_url} data-action="share/whatsapp/share"></a>

	   	</li>);
   		
   		return (
   			<div className="job-share">
   				<h4>{LanguageStore.get('job_ad/title/share').toUpperCase()}</h4>
   				<ul className="list">
   					<li>
   						<a onClick={this.openUrl} className="fa fa-twitter-square twitter" target="_blank" href={twitter_url}></a>
   					</li>
   					<li>
   						<a onClick={this.openUrl} className="fa fa-facebook-square facebook" target="_blank" href={facebook_url}></a>
   					</li>
   					<li>
   						<a onClick={this.openUrl} className="fa fa-linkedin-square linkedin" target="_blank" href={linkedin_url}></a>
   					</li>
	   				<li>
	   					<a className="fa fa-envelope-square mailto" href={mailto}></a>
	   				</li>
	   				
	   				{whatsapp_el}
	   				
				</ul>
				<div className="clear"></div>
	  		</div>
	  	);
	}
});
